import classNames from 'classnames';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { UI_Link } from 'ui/components/1-atoms/Action/Link/Link';
import styles from './Navigation.module.scss';

export interface UI_NavigationProps {
	className?: string;
	style?: 'primary';
	heading?: string;
	navigationItems?: Array<UI_NavigationItemProps>;
}

export interface UI_NavigationItemProps {
	id: number;
	name: string;
	url: string;
	descendants?: Array<UI_NavigationItemProps>;
	current?: boolean;
	active?: boolean;
	hidden?: boolean;
	title?: string;
}

export const UI_Navigation: React.FC<UI_NavigationProps> = ({ className, style, heading, navigationItems }) => (
	<nav className={classNames(styles.Navigation, styles[`Navigation___${style}`], className)} role="navigation">
		{heading && (
			<UI_Heading headingLevel="h6" className={styles.Navigation_heading}>
				{heading}
			</UI_Heading>
		)}
		<ul className={styles.Navigation_list}>
			{navigationItems &&
				navigationItems.map((navigationItem: UI_NavigationItemProps, index) => (
					<li key={index} className={classNames(styles.Navigation_item)}>
						<UI_Link
							href={navigationItem.url}
							style="xl"
							className={classNames(styles.Navigation_link, {
								[styles.isActive]: navigationItem.active === true,
								[styles.isCurrent]: navigationItem.current === true,
							})}
						>
							{navigationItem.title || navigationItem.name}
						</UI_Link>
					</li>
				))}
		</ul>
	</nav>
);
